import { Doughnut } from 'react-chartjs-2';
import { Box, Card, CardContent, CardHeader, Divider, Typography, useTheme } from '@mui/material';
import LaptopMacIcon from '@mui/icons-material/PriorityHighRounded';
import TabletIcon from '@mui/icons-material/Done';
import PhoneIcon from '@mui/icons-material/Block';
import { faker } from '@faker-js/faker';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const TrafficByDevice = ({ props, dataLength }) => {
  const theme = useTheme();
  const labels = ['Pendentes', 'Aprovados', 'Negados'];

  const data = {
    datasets: [
      {
        data: [1, 1, 1], //dataLength,
        backgroundColor: ['#FB8C00', '#00FF27', '#e53935'],
        borderWidth: 8,
        borderColor: '#FFFFFF',
        hoverBorderColor: '#FFFFFF'
      }
    ],
    labels: labels
  };

  const options = {
    animation: false,
    cutout: '80%',
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: theme.palette.background.paper,
        bodyColor: theme.palette.text.secondary,
        borderColor: theme.palette.divider,
        borderWidth: 1,
        enabled: true,
        footerColor: theme.palette.text.secondary,
        intersect: false,
        mode: 'index',
        titleColor: theme.palette.text.primary
      }
    },
    maintainAspectRatio: false,
    responsive: true
  };

  const devices = [
    {
      title: 'Unidades',
      value: ((data.datasets[0].data[0] / (data.datasets[0].data[0] + data.datasets[0].data[1] + data.datasets[0].data[2])) * 100).toFixed(2),
      icon: LaptopMacIcon,
      color: '#FB8C00'
    },
    {
      title: 'Locais',
      value: ((data.datasets[0].data[1] / (data.datasets[0].data[0] + data.datasets[0].data[1] + data.datasets[0].data[2])) * 100).toFixed(2),
      icon: TabletIcon,
      color: '#00FF27'
    },
    {
      title: 'Objetos',
      value: ((data.datasets[0].data[2] / (data.datasets[0].data[0] + data.datasets[0].data[1] + data.datasets[0].data[2])) * 100).toFixed(2),
      icon: PhoneIcon,
      color: '#e53935'
    }
  ];

  return (
    <Card {...props} sx={{ backgroundColor: '#fff', }}>
      <CardHeader title="Requerimentos por situação" sx={{ color: '#252525' }} />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative'
          }}
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
          }}
        >
          {devices.map(({
            color,
            icon: Icon,
            title,
            value
          }) => (
            <Box
              key={title}
              sx={{
                p: 1,
                textAlign: 'center',
              }}
            >
              <Icon color="primary" />
              <Typography
                color="#fff"
                variant="body1"
              >
                {title}
              </Typography>
              <Typography
                style={{ color }}
                variant="h4"
              >
                {value}
                %
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default TrafficByDevice;